module.exports = __webpack_public_path__ + "static/img/Header_1920x380_reproductive-health-monogenic-disease.7400797.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/headerimg/Header_1920x380_reproductive-health-monogenic-disease.jpg
// module id = Qgho
// module chunks = 0